export const SITE_NAVIGATION = [
  { id: 'home', href: '/', label: 'Home' },
  { id: 'about', href: '/about', label: 'About' },
  { id: 'legal', href: '/legal', label: 'Legal' },
  { id: 'contact', href: '/contact', label: 'Contact' },
] as const;
